"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.viewDataSelector = viewDataSelector;
function viewDataSelector(state) {
  return state.view.data;
}